import { applyMiddleware, compose, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import searchReducer from "./service/search";
import accountReducer from "./service/account";
import appointmentReducer from "./service/appointments";
import currentAccountReducer from "@/modules/currentAccount/reducers";
import * as listReducer from "@/modules/list/reducers";
import * as formReducer from "@/modules/forms/reducers";
import * as searchDataReducer from "@/modules/search/reducers";
import * as dataFetcher from "@/modules/dataFetcher/reducer";
import * as modal from "@/modules/modal/reducers";
import { createReducer, apiMiddleware } from "./utils/store";

const rootReducer = combineReducers({
  // router: routerReducer,
  search: searchReducer,
  account: accountReducer,
  currentAccount: currentAccountReducer,
  appointment: appointmentReducer,
  list: createReducer(listReducer),
  forms: createReducer(formReducer),
  searchData: createReducer(searchDataReducer),
  fetcher: createReducer(dataFetcher),
  modal: createReducer(modal),
});



const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

export const store = {
  ref: null,
};

export const initStore = () => {
  store.ref = createStore(
    rootReducer,
    {},
    composeEnhancers(applyMiddleware(thunk, apiMiddleware))
  );
  return store.ref;
};

export const wrapper = initStore();
